var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_setup.props.size,"height":_setup.props.size,"viewBox":"0 0 24 24","fill":_vm.fill,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }